export default "__VITE_ASSET__DzcwuO32__"